import SEO from '@/components/landing/seo';
import Footer from '@/components/layout/landing/Footer';
import NavbarNew from '@/components/layout/landing/NavbarNew';
import MockTestByCourseList from '@/components/mock-test/MockTestByCourseList';
import { GetServerSideProps } from 'next';
import { useSelector } from 'react-redux';

const CourseMockTest = (props) => {
  const mockTestLanding = useSelector(
    (state: any) => state?.MockTestReducer?.mockTestLanding
  );

  return (
    <>
      <SEO
        meta_title={
          mockTestLanding?.data?.data?.length > 0
            ? mockTestLanding?.data?.data[0]?.meta_title
            : 'Mock test List - Learnsic'
        }
        meta_description={
          mockTestLanding?.data?.data?.length > 0
            ? mockTestLanding?.data?.data[0]?.meta_description
            : 'Prepare for your upcoming MOCK Test with confidence and ace your exams. Our comprehensive MOCK Test preparation materials cover a wide range of subjects, providing you with the knowledge and practice you need to succeed. Get ready to excel with realistic exam simulations and detailed answer explanations. Start your preparation today and take your MOCK Test performance to the next level.'
        }
        meta_keywords={
          mockTestLanding?.data?.data?.length > 0
            ? mockTestLanding?.data?.data[0]?.meta_keywords
            : 'CEE, CMAT, KUMAT, BE, BSCIT, MOCK Test, A leve, +2, NEB, TU, IOM, IOE'
        }
        photo={
          mockTestLanding?.data?.data?.length > 0
            ? mockTestLanding?.data?.data[0]?.image
            : 'https://s3.ap-south-1.amazonaws.com/learnsic.com/banner/Mocktest-cover.png'
        }
        canonical={`mock-test/${props?.slug}`}
      />
      <NavbarNew />

      <MockTestByCourseList
        total={mockTestLanding?.total ? mockTestLanding?.total : 10}
        loading={mockTestLanding?.loading}
        isCourseDetailComponent={false}
        courseSlug={props?.slug}
      />
      <Footer />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  return {
    props: {
      slug: context.query.slug,
    },
  };
};

export default CourseMockTest;
